import { Box, Center, Container, Heading, Image, Link, SimpleGrid, Text } from '@chakra-ui/react'
import Card from 'components/Card'
import SEO from 'components/SEO'
import { NextPage } from 'next'
import NextLink from 'next/link'
import sortBy from 'lodash.sortby'

type Speciality = Record<string, any>

interface ServicesProps {
  specialities: Speciality[]
}

const Services: NextPage<ServicesProps> = ({ specialities }) => {
  const sortedSpecialities = sortBy(specialities, 'attributes.displayPriority').reverse()

  return (
    <Box marginY="3rem" backgroundColor="gray.100">
      <SEO
        title="Usługi prywatna przychodnia medyczna"
        description="Medwind z Poznania oferuje usługi Chirurgia, Laryngologia, Otolaryngologia, Rehabilitacja i Fizjoterapia, Psychologia, Dietetyka, Logopedia, Ortopedia, Zajęcia grupowe."
      />
      <Container maxWidth="container.xl" paddingY="3rem">
        <Heading size="lg">Nasze usługi</Heading>
        <Text marginTop="1rem" fontSize="1.25rem" lineHeight={1.75}>
          W celu umówienia wizyty prosimy o kontakt telefoniczny
          <br />z recepcją pod numerem <Link href="tel:61 830 60 30">61 830 60 30</Link>.
        </Text>
        <SimpleGrid columns={[1, 2, 3]} marginTop="2rem" gap="2rem">
          {sortedSpecialities?.map((speciality) => {
            const icon = speciality.attributes?.icon?.data
            return (
              <NextLink key={speciality.id} href={`/specjalnosc/${speciality.attributes.slug}`} passHref>
                <Card backgroundColor="white" cursor="pointer">
                  <Center flexDirection="column" padding="2rem">
                    <Image src={icon?.attributes?.url} alt={speciality.attributes.name} boxSize="4rem" />
                    <Heading size="md" marginTop="1rem">
                      {speciality.attributes.name}
                    </Heading>
                  </Center>
                </Card>
              </NextLink>
            )
          })}
        </SimpleGrid>
      </Container>
    </Box>
  )
}

export async function getServerSideProps() {
  const URL = `${process.env.NEXT_PUBLIC_API_URL}/api/specialities?populate=icon`
  const res = await fetch(URL)
  const { data } = await res.json()
  return { props: { specialities: data } }
}

export default Services
